import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class SecurityTransferSearchCriteria extends ValueObject {

    public searchCriteria: string = "";
}